// extracted by mini-css-extract-plugin
export default {"details":"FilterCard_details__9LbVw","summary":"FilterCard_summary__LAi+r","button":"FilterCard_button__5CpRh"};